// @ts-check
// Estado "sem acesso" das telas de Campanhas (spec-2.0.0 seção 4.10, [BASE 2.6]; contrato 09 de campanhas base): o
// papel não tem a flag da tela ou não lê o card. Só tokens do tema; no celular o estado centraliza com 16 px de margem.
import { html } from 'htm/preact';
import { navigate } from '../../app/router.js';
import { PageCard, PageHeader } from '../page/page-card.js';
import { EmptyState } from '../../ui/feedback.js';
import { Button } from '../../ui/button.js';
import { t } from '../../i18n/index.js';
import { campaignScreenByKey } from '../../../../shared/navigation/screen-access.js';

/** @typedef {import('../../../../shared/navigation/screen-access.js').CampaignScreenKey | 'home'} CampaignScreenGuardKey */

/** @param {{ screenKey: CampaignScreenGuardKey }} props */
export function CampaignsNoAccess({ screenKey }) {
  const screen = screenKey === 'home' ? null : campaignScreenByKey(screenKey);
  return html`<${PageCard}
    className="campaigns-screen"
    header=${html`<${PageHeader} icon=${screen?.icon ?? 'IconSpeakerphone'} title=${t(screen?.labelKey ?? 'campaignsBase.screens.home')} />`}
  >
    <div class="page-centered campaigns-state" data-testid="campaigns-no-access">
      <${EmptyState}
        icon="IconForbid"
        title=${t('campaignsBase.noAccess.title')}
        subtitle=${t(`campaignsBase.noAccess.description.${screenKey}`)}
        action=${html`<${Button} variant="secondary" title=${t('campaignsBase.noAccess.back')} onClick=${() => navigate('/')} />`}
      />
    </div>
  <//>`;
}
